import './Microfrontend.css';

import { ChakraProvider } from '@chakra-ui/react';
import { ThemeProvider } from '@descomplica/design-system-react';
import { observer, useViewModel } from '@descomplica/microfrontend-react';
import React from 'react';
import styled from 'styled-components';

import envs from '@/infrastructure/config/envs';

import chakraTheme from './chakra-theme';
import ErrorMessageWithIllustration from './components/error-message-with-illustration';
import { FullPageLoading } from './components/fullpage-loading';
import { BaseLayout } from './layouts/base/base.layout';
import { MicrofrontendViewModel } from './Microfrontend.vm';
import { Router } from './router';

const Microfrontend = () => {
  useViewModel(MicrofrontendViewModel);

  return (
    <div className="classroom-mf-container">
      <ChakraProvider theme={chakraTheme}>
        <ThemeProvider library="core" theme="light">
          <BaseLayout>
            <SplashScreen />
          </BaseLayout>
        </ThemeProvider>
      </ChakraProvider>
    </div>
  );
};

const Container = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
`;

const SplashScreen = observer(() => {
  const vm = useViewModel(MicrofrontendViewModel);

  if (vm.isLoading) {
    return (
      <Container>
        <FullPageLoading />
      </Container>
    );
  }

  if (vm.hasPermissionError) {
    vm.clearAccount();
    window.location.href = envs.recognitionSigninUrl;
  }

  if (vm.hasError) {
    return (
      <Container>
        <ErrorMessageWithIllustration errorMessage="Oops! Ocorreu uma falha ao tentar iniciar a aplicação. Recarregue a página ou tente novamente mais tarde" />
      </Container>
    );
  }

  return <Router />;
});

export default Microfrontend;
